import http from '../config/httpconfig'

/**
 * 根据Code获取用户信息 
 */
export const req_wxLogin = params => {
    return http.get('/syslogin/wxLogin', params)
}

// 查询受访类型
export const req_findVisitorType = params => {
    return http.get('/visitortype/findVisitorType', params)
}

// 查询受访部门信息
export const req_findSysDep = params => {
    return http.get('/sysdep/findSysDep', params)
}

// 新增拜访记录信息
export const req_saveApprovalRecord = params => {
    return http.post('/approvalrecord/saveApprovalRecord', params)
}

// 根据部门id查询教师信息
export const req_findSysTeacher = params => {
    return http.get('/systeacher/findSysTeacher', params)
}

// 根据部门id和输入内容查询教师信息
export const req_getTeacherByName = params => http.get('/systeacher/getTeacherByName', params)


// 拍照上传图片
export const req_uploadImage = params => {
    return http.upload('/approvalrecord/uploadImage', params)
}

// 查询我的申请记录
export const req_findMyRecord = params => {
    return http.get('/approvalrecord/findMyRecord', params)
}

// 根据记录id查询记录详情
export const req_findRecordById = params => {
    return http.get('/approvalrecord/findRecordById', params)
}

// 教师审核申请记录信息
export const req_shenpiRecord = params => {
    return http.post('/approvalrecord/shenpiRecord', params)
}

// 获取用户信息
export const req_getTeacherInfo = params => {
    return http.get('/cas/getTeacherInfo', params)
}

// 根据教师工号查询有关该教师的申请记录
export const req_findTeacherRecord = params => {
    return http.get('/systeacher/findTeacherRecord', params)
}

// 查询登陆人最近一次的拜访申请信息
export const req_findRecordInfo = params => {
    return http.get('/approvalrecord/findRecordInfo', params)
}

// 根据教师工号查询教师信息
export const req_findTeacher = params => {
    return http.get('/systeacher/findTeacher', params)
}

// 生成分享链接使用
export const req_createUrl = params => {
    return http.get('/approvalrecord/createUrl', params)
}

// 查询配置
export const getConfig = params => {
    return http.get('/systemconfig/getConfig', params)
}
